export default __webpack_public_path__ + "static/media/01.99df0081.png";